import React, { useState, useEffect, createRef } from 'react';

import FrameRangeSlider from './FrameRangeSlider';

const Trimmer = ({
  videoDuration,
  videoURL,
  reRecordVideo,
  onUploadVideo,
  setTrimPoints,
  fromUpload,
  isRegional = false,
  orgPrefix
}) => {
  const [rangeValue, setRangeValue] = useState([0, videoDuration]);

  const trimmedVideoRef = createRef();

  const goBack = () => {
    reRecordVideo();
  };

  useEffect(() => {
    setTrimPoints(rangeValue);
    if (!trimmedVideoRef.current || trimmedVideoRef.src) return;

    trimmedVideoRef.current.currentTime = rangeValue[0];
    trimmedVideoRef.current.play();
  }, [rangeValue]);

  return (
    <div className="video-trimmer container mx-auto max-w-2xl">
      <div className={isRegional ? 'h-[calc(100vh-40rem)] mx-auto' : 'video-container !h-96'}>
        <video
          ref={trimmedVideoRef}
          src={videoURL}
          start={rangeValue[0]}
          end={rangeValue[1]}
          className={
            isRegional ? 'h-[calc(100vh-40rem)] mx-auto' : 'video-player !h-full w-auto max-w-full'
          }
          autoPlay
          playsInline
          loop
          controls
          onTimeUpdate={(e) => {
            if (e.target.currentTime >= rangeValue[1]) {
              e.target.currentTime = rangeValue[0];
              e.target.play();
            }
            if (e.target.currentTime < rangeValue[0] && rangeValue[0] !== 0) {
              e.target.currentTime = rangeValue[0];
              e.target.play();
            }
          }}
        />
        {/* <div className="btn-player-container">
          <button className="btn btn-player">
            <FaRegPlayCircle className="icon" />
          </button>
        </div> */}
      </div>
      <div className="my-4">
        <FrameRangeSlider
          videoURL={videoURL}
          videoDuration={videoDuration}
          onRangeChange={(value) => {
            setRangeValue(value);
            setTrimPoints(value);
          }}
          frameCount={20}
          orgPrefix={orgPrefix}
        />
      </div>
      {isRegional && (
        <div className="flex flex-row justify-center gap-4 fixed bottom-3 left-0 right-0 border-t border-cblack-default pt-4">
          {fromUpload ? (
            <>
              <button
                className="w-fit px-4 py-2 text-white rounded-xl bg-cblue-500"
                onClick={onUploadVideo}>
                Télécharger
              </button>
              <button className="w-fit px-5 py-2 rounded-xl border-2 border-black" onClick={goBack}>
                Remplacer la vidéo
              </button>
            </>
          ) : (
            <>
              <button
                className="bg-white text-cblue-500 border-2 border-cblue-500 rounded-xl px-4 py-2"
                onClick={goBack}>
                Réenregistrer la vidéo
              </button>
              <button
                className="bg-cblue-500 text-white border-2 border-cblue-500 rounded-xl px-4 py-2"
                onClick={onUploadVideo}>
                Télécharger
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Trimmer;
